export const fetchCandidate = (BeURL, currentUser, setCandidate, setError, id,) => {


    // if (currentUser.role === 'job-seeker') {
    fetch(`${BeURL}/fetch-profile-data`, {
        method: 'POST',
        credentials: 'include',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: currentUser._id })
    })
        .then(res => res.json())
        .then(json => {
            if (json.success) setCandidate(json.user);
            else throw new Error(json.message);
        })
        .catch(err => setError(err.message))
    // }

    // else {
    //     fetch(`${BeURL}/fetch-candidate/${id}`, {
    //         credentials: 'include'
    //     })
    //         .then(res => res.json())
    //         .then(json => {
    //             if (json.success) setCandidate(json.candidate);
    //             else throw new Error(json.message);
    //         })
    //         .catch(err => setError(err.message))

    // }
}

export const fetchCandidateExperience = (BeURL, id, currentPage, rowsPerPage, setTotalExperience, setTotalPage, setExperinces) => {

    if (!BeURL || !id) {
        alert("")
        return
    }
    fetch(`${BeURL}/getcandidate-experience/${id}`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ pages: currentPage, experiencePerpage: rowsPerPage }),
    })
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                setExperinces(data.experience)
                setTotalPage(data.totalPages)
                setTotalExperience(data.totalExperience)
            }
            // else {
            //     alert(data.message)
            // }
        })
        .catch(err => {
            console.log("Error in experience  fetch", err)
        })
}

// BeURL, candidate._id, currentPage, rowsPerPage, setTotalEducation, setTotalPage, setEducations
export const fetchCandidateEducation = (BeURL, id, currentPage, rowsPerPage, setTotalEducation, setTotalPage, setEducations) => {

    if (!BeURL || !id) {
        alert("")
        return
    }
    fetch(`${BeURL}/get-candidate-education/${id}`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ pages: currentPage, educationPerpage: rowsPerPage }),
    })
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                setEducations(data.educations)
                setTotalPage(data.totalPages)
                setTotalEducation(data.totalEducation)
            }
           
        })
        .catch(err => {
            console.log("Error in Education Fetch", err)
        })
}


export const fetchPrimarySkills = (BeURL, id, primaryCurrentPage, rowsPrimaryPerPage, setTotalPrimarySkill, setTotalPrimaryPage, setPrimarySkill, showAlert) => {

    if (!BeURL || !id) {
        alert("")
        return
    }
    fetch(`${BeURL}/candidate-get-primaryskill/${id}`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ pages: primaryCurrentPage, primarySkillPerPage: rowsPrimaryPerPage }),
    })
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                setPrimarySkill(data.primarySkills)
                setTotalPrimaryPage(data.totalPages)
                setTotalPrimarySkill(data.totalPrimarySkills)
            }

        })
        .catch(err => {
            console.log("Error in skills updated", err)
        })
}


export const fetchSecondarySkills = (BeURL, id, currentPage, rowsPerPage, setTotalSkill, setTotalPage, setSecondarySkill, showAlert) => {

    if (!BeURL || !id) {
        alert("")
        return
    }
    fetch(`${BeURL}/candidate-get-secondaryskill/${id}`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ pages: currentPage, secondarySkillPerPage: rowsPerPage }),
    })
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                setSecondarySkill(data.secondarySkills)
                setTotalPage(data.totalPages)
                setTotalSkill(data.totalSecondarySkills)
            }
            // else {
            //     showAlert(data.message)
            // }
        })
        .catch(err => {
            console.log("Error in skills updated", err)
        })
}

export const fetchCertificate = (BeURL, id, currentPage, rowsPerPage, setTotalItems, setTotalPage, setCertificate, showAlert, setLoading) => {

    if (!BeURL || !id) {
        showAlert("BeURL or Id is missing")
        return
    }
    fetch(`${BeURL}/candidate-get-certificate/${id}`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ pages: currentPage, certificatePerPage: rowsPerPage }),
    })
        .then(res => res.json())
        .then(data => {
            setLoading(false)

            if (data.success) {
                setCertificate(data.certificates)
                setTotalPage(data.totalPages)
                setTotalItems(data.totalCertificates)
            }

        })
        .catch(err => {
            console.log("Error in fetching candidates certificates", err)
            showAlert("Trouble in connecting to the Server! kindly try again later.")
        })
}

export const fetchProject = (BeURL, id, currentPage, rowsPerPage, setTotalItems, setTotalPage, setProjects, showAlert, setLoading) => {

    if (!BeURL || !id) {
        alert("BeURL or Id is missing")
        return
    }
    fetch(`${BeURL}/candidate-get-projects/${id}`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ pages: currentPage, projectPerPage: rowsPerPage }),
    })
        .then(res => res.json())
        .then(data => {
            setLoading(false)
            if (data.success) {
                setProjects(data.projects)
                setTotalPage(data.totalPages)
                setTotalItems(data.totalProjects)
            }
            // else {
            //     showAlert(data.message)
            // }
        })
        .catch(err => {
            console.log("Error in fetching candidates Projects:", err)
            showAlert("Trouble in connecting to the Server! kindly try again later.")
        })
}

export const fetchSocials = (BeURL, id, currentPage, rowsPerPage, setTotalProfiles, setTotalPage, setProfiles, showAlert,setLoading) => {

    if (!BeURL || !id) {
        alert("BeURL or Id is missing")
        return
    }
    fetch(`${BeURL}/candidate-get-socials/${id}`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ pages: currentPage, socialPerPage: rowsPerPage }),
    })
        .then(res => res.json())
        .then(data => {
            setLoading(false)
            if (data.success) {
                setProfiles(data.socials)
                setTotalPage(data.totalPages)
                setTotalProfiles(data.totalSocials)
            }
            // else {
            //     showAlert(data.message)
            // }
        })
        .catch(err => {
            console.log("Error in fetching social profiles:", err)
            showAlert("Trouble in connecting to the Server! kindly try again later.")
        })
}